"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelHiddenImageVisibility = exports.CollectionModelHiddenImageVisibilityMutator = void 0;
const imageVisibility_1 = require("./imageVisibility");
class CollectionModelHiddenImageVisibilityMutator extends imageVisibility_1.CollectionModelImageVisibilityMutator {
    constructor(imageVisibility) {
        super(imageVisibility);
    }
    init(hidden) {
        this.imageVisibility.imageVisibilityState.Mutator.create('hidden');
        this.setHidden(hidden);
    }
    setHidden(hidden) {
        const state = this.getValue();
        state.hidden = hidden;
        this.setValue(state);
    }
}
exports.CollectionModelHiddenImageVisibilityMutator = CollectionModelHiddenImageVisibilityMutator;
class CollectionModelHiddenImageVisibility extends imageVisibility_1.CollectionModelImageVisibility {
    constructor() {
        super(...arguments);
        this.tag = CollectionModelHiddenImageVisibility.TAG;
        this.Mutator = new CollectionModelHiddenImageVisibilityMutator(this);
    }
    static state(id) {
        return {
            id,
            tag: 'hidden',
            hidden: false,
        };
    }
    static isHidden(t) {
        return (t === null || t === void 0 ? void 0 : t.tag) === CollectionModelHiddenImageVisibility.TAG;
    }
    get hidden() {
        const state = this.state;
        if (!state) {
            return false;
        }
        return state.hidden;
    }
}
exports.CollectionModelHiddenImageVisibility = CollectionModelHiddenImageVisibility;
CollectionModelHiddenImageVisibility.TAG = 'hidden';
//# sourceMappingURL=hidden.imageVisibility.js.map